import { useMemo } from "react"

/**
 * Hook to check if any permission(s) exist in the user's permission list.
 * @param {Array<string>} userPermissions - List of user's permissions.
 * @param {string | Array<string>} checkPermissions - Permission(s) to check.
 * @returns {boolean} - true if any checkPermissions are present in userPermissions.
 */
const useHasPermission = (userPermissions, checkPermissions) => {
  return useMemo(() => {
    if (!userPermissions || !Array.isArray(userPermissions)) return false

    const permissionsToCheck = Array.isArray(checkPermissions)
      ? checkPermissions
      : [checkPermissions]

    return permissionsToCheck.some((p) => userPermissions.includes(p))
  }, [userPermissions, checkPermissions])
}

export default useHasPermission
